import './copilot-glow.css';

/**
 * Animated iridescent halo behind CopilotAvatar, CSS-only (see copilot-glow.css).
 * Reduced motion shows a static halo via Tailwind's motion-reduce variant.
 */
export function CopilotGlow() {
  return (
    <>
      <span
        aria-hidden
        className="pointer-events-none absolute -inset-1.5 hidden rounded-full bg-[conic-gradient(from_0deg,#38bdf8,#818cf8,#e879f9,#fb7185,#22d3ee,#38bdf8)] opacity-70 blur-[6px] motion-reduce:block"
      />
      <span
        aria-hidden
        className="copilot-glow-wash pointer-events-none absolute -inset-1.5 rounded-full bg-[conic-gradient(from_200deg,#38bdf8,#818cf8,#e879f9,#fb7185,#22d3ee,#38bdf8)] opacity-80 blur-[6px] motion-reduce:hidden"
      />
      <span
        aria-hidden
        className="copilot-glow-blob copilot-glow-blob-sky pointer-events-none absolute -inset-1 rounded-full bg-sky-400/80 blur-[5px] motion-reduce:hidden"
      />
      <span
        aria-hidden
        className="copilot-glow-blob copilot-glow-blob-fuchsia pointer-events-none absolute -inset-1 rounded-full bg-fuchsia-400/75 blur-[5px] motion-reduce:hidden"
      />
      <span
        aria-hidden
        className="copilot-glow-blob copilot-glow-blob-violet pointer-events-none absolute -inset-1 rounded-full bg-violet-400/70 blur-[5px] motion-reduce:hidden"
      />
    </>
  );
}
